import { render } from "./VaultSummary.vue?vue&type=template&id=782af407&ts=true"
import script from "./VaultSummary.vue?vue&type=script&lang=ts"
export * from "./VaultSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__